module.exports = __webpack_public_path__ + "static/media/am.9942129f.svg";